<template>
  <!-- 添加应用名称对话框 -->
  <el-dialog title="新建应用"
             :visible.sync="paramShow.addAppVisible"
             :close-on-click-modal="false"
             width="50%"
             @close="DialogClosed('addAppFormRef')">
    <el-form :model="addAppForm"
             :rules="addAppFormRules"
             ref="addAppFormRef"
             label-width="100px"
             @submit.native.prevent>
      <el-form-item label="应用名称"
                    prop="appName">
        <el-input v-model="addAppForm.appName"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="paramShow.addAppVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="addAppInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import http from '@/http/index.js'

export default {
  props: ['paramShow'],
  data() {
    return {
      addAppForm: {
        appName: null
      },
      addAppFormRules: {
        appName: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          {
            max: 20,
            message: '应用名称超长，最长支持20字符',
            trigger: 'blur'
          }
          // { validator: checkAppName, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    // 创建新应用
    async addAppInfo() {
      const valid = await this.$refs.addAppFormRef.validate();
      if (!valid) return;
      // 发起添加应用名称请求
      await http.app.add({
        name: this.addAppForm.appName
      });
      this.paramShow.addAppVisible = false;
      // 刷新数据列表
      this.$emit('updateList');
      this.$message.success('添加应用成功！');
    },
    DialogClosed(ref) {
      this.$refs[ref].resetFields();
    }
  },
  created() {
    //
  }
};
</script>

<style lang="less" scoped>
</style>
